"use client";

import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/ui/reveal";
import { Section } from "@/components/ui/section";
import { Sheet } from "@/components/ui/sheet";
import { useState } from "react";

export function InviteRulesStrip({
  stripText,
  actionLabel,
  sheet,
}: {
  stripText: string;
  actionLabel: string;
  sheet: {
    title: string;
    items: readonly string[];
    note: string;
    closeLabel: string;
  };
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Section tight className="bg-hirudin-bg/55" aria-labelledby="hirudin-invite-title">
        <Reveal className="flex items-center justify-between gap-3">
          <p
            id="hirudin-invite-title"
            className="max-w-[14rem] text-sm leading-[1.8] font-medium text-ink"
          >
            {stripText}
          </p>
          <Button variant="text" onClick={() => setOpen(true)}>
            {actionLabel}
          </Button>
        </Reveal>
      </Section>

      <Sheet open={open} onOpenChange={setOpen} title={sheet.title}>
        <ol className="space-y-2 border-y border-line py-3">
          {sheet.items.map((item, index) => (
            <li key={item} className="flex gap-3 text-sm leading-[1.6] text-ink-2">
              <span className="font-mono text-xs text-forest-500">
                {String(index + 1).padStart(2, "0")}
              </span>
              <span>{item}</span>
            </li>
          ))}
        </ol>
        <p className="mt-3 text-[11px] leading-[1.6] text-ink-3">{sheet.note}</p>
        <Button variant="brand" className="mt-5 w-full" onClick={() => setOpen(false)}>
          {sheet.closeLabel}
        </Button>
      </Sheet>
    </>
  );
}
